import React from 'react';
import { SortableContainer } from 'react-sortable-hoc';
import GroupContainer from './GroupContainer';
import Locking from './Locking';

const LockingsList = ({ activeLockingId, lockings, onClick }) => (
	<div className="lockings-list">
		{lockings.map((locking, index) => {
			const commonProps = {
				key: locking.locking_id,
				id: locking.locking_id,
				index,
				locking,
				onClick
			};

			const isGroup = locking.is_locking === false;
			if (isGroup) {
				const sortableProps = {
					lockAxis: 'y'
				};

				return (
					<GroupContainer
						{...commonProps}
						{...sortableProps}
						activeLockingId={activeLockingId}
					/>
				);
			}

			const isActive = locking.locking_id === activeLockingId;

			return <Locking {...commonProps} active={isActive} />;
		})}
	</div>
);

export default SortableContainer(LockingsList);



// WEBPACK FOOTER //
// ./src/js/plan/lockings/LockingsList.js